import { useState } from "react";
import { auth, db } from "../../../firebase/config";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";

import "./Login.css"
import Header from "../../../components/common/Header/Header";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // 1. Autenticação básica
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Busca o papel (role) do usuário no Firestore
      const userDocRef = doc(db, "users", user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();

        // 3. Redirecionamento baseado na Role
        if (userData.role === "admin") {
          navigate("/");
        } else {
          navigate("/"); // Cliente comum vai para a home/loja
        }
      } else {
        // Caso o usuário exista no Auth mas não no Firestore (raro, mas possível)
        setError("Perfil de usuário não encontrado.");
      }

    } catch (err) {
      // Tratamento de erros amigável
      if (err.code === 'auth/invalid-credential') {
        setError("E-mail ou senha incorretos.");
      } else {
        setError("Erro ao entrar. Verifique sua conexão.");
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    // 1. Esta div centraliza tudo na tela (preto profundo)
    <div className="login-screen">
      <Header/>
      <div className="login-container">
        
        <header className="login-header">
          <span>REPIQUE</span>
          <h1>Entrar</h1>
          <div className="divider"></div>
        </header>

        <form onSubmit={handleLogin} className="login-form">
          
          {error && <p className="error-message">{error}</p>}

          {/* Grupo de E-mail */}
          <div className="input-group">
            <label htmlFor="email">E-MAIL</label>
            <input 
              id="email"
              type="email" 
              placeholder="seu@email.com" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
          </div>

          {/* Grupo de Senha */}
          <div className="input-group">
            <label htmlFor="password">SENHA</label>
            <input 
              id="password"
              type="password" 
              placeholder="••••••••" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
            />
          </div>

          {/* Botão Estilizado */}
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? "Entrando..." : "Acessar Conta"}
          </button>
        </form>

        <footer className="login-footer">
          <p>
            Não tem uma conta? 
            <Link to="/register">Cadastre-se aqui</Link>
          </p>
          <button 
            type="button" 
            className="btn-forgot-password" 
            onClick={() => navigate("/forgot-password")}
          >
            ESQUECEU A SENHA?
          </button>
        </footer>
      </div>
    </div>
  );
}